/**
 * Created by mh on 2017/5/23.
 */
import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import AssetTable from './AssetTable';

@observer
class AssetRelated extends Component {
    render() {
        const { columns, related } = this.props;
        // Only display if any
        if (related && related.length > 0) {
            return (
                <section>
                    <h4>
                        <FormattedMessage id="Assets.Related" defaultMessage="Related" />
                    </h4>

                    <AssetTable assets={related} columns={columns} />

                </section>
            );
        }
        return null;
    }
}

AssetRelated.propTypes = {
    related: PropTypes.object.isRequired,
    columns: PropTypes.array.isRequired,
};

export default injectIntl(AssetRelated);
